import React, { Component, useMemo } from "react";
import { Link } from "react-router-dom";
import DataTable from "../_Components/DataTable";
import SplitNumber from "../_Components/SplitNumber";
import _ from "lodash";
import moment from "moment-jalaali";

function DataGrid({ data }) {
  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "userType",
        Header: "نوع حساب",
        minWidth: "100px",
      },
      {
        accessor: "userFullName",
        Header: "نام",
        minWidth: "100px",
      },
      {
        accessor: "phoneNumber",
        Header: "شماره تماس",
        minWidth: "100px",
      },
      {
        accessor: "accountOwnerName",
        Header: "صاحب حساب",
        minWidth: "100px",
      },
      {
        accessor: "companyName",
        Header: "شرکت",
        minWidth: "100px",
      },
      {
        accessor: "rialAmount",
        Header: "مبلغ",
        minWidth: "100px",
        maxWidth: "100px",
        Cell: ({ row }) => (
          <div className="">
            <SplitNumber number={row.original.rialAmount} />
          </div>
        ),
        Footer: (info) => {
        
          const total = React.useMemo(() => info.rows.reduce((sum, row) => row.original.rialAmount + sum, 0), [info.rows]);
          return (
            <div className="text-center success">
              {" "}
              <SplitNumber number={total} />
            </div>
          );
        },
      },
      {
        accessor: "statusS",
        Header: "وضعیت",
        minWidth: 100,
        Cell: ({ row }) => (
          <div
            className={` rounded-pill d-inline-block px-4 py-1 text-center ${row.original.status === 4 ? "text-danger bg-light-danger" : row.original.status === 3 ? "text-success bg-light-success" : row.original.status === 1 ? "bg-light-info text-info" : "text-primary bg-light-primary"}`}
          >
            {row.original.statusS}
          </div>
        ),
      },
      {
        Header: "تاریخ انجام",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {_.toString(row.original.paymentDate)} - {_.toString(row.original.paymentTime)}
          </div>
        ),
      },
      {
        accessor: "createdPersianTime",
        Header: "زمان ایجاد",
        minWidth: 100,
      },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {/* ویرایش */}
            <Link
              title="ویرایش"
              className="btn btn-light-primary btn-sm mr-2 btn-icon"
              to={{
                pathname: `/userWithdrawalsDetails/${row.original.id}`,
                state: { accountType: row.original.userType },
              }}
            >
              <i className="far fa-edit text-small"></i>
            </Link>
          </div>
        ),
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    show_footer: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
